import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Icons } from 'greener-ui-library';
import { ReactNode } from 'react';

interface InstructionModalProps {
  /** Button trigger element */
  trigger: ReactNode;
  /** Modal title */
  title: string;
  /** Modal content */
  children: ReactNode;
  /** Whether modal is open */
  open: boolean;
  /** Callback when modal should close */
  onClose: () => void;
}

export const InstructionModal = ({ trigger, title, children, open, onClose }: InstructionModalProps) => {
  return (
    <>
      {trigger}
      <Dialog data-testid="instruction-modal" open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {title}
          <IconButton onClick={onClose} size="small">
            <Icons.Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </>
  );
};
